import { render, staticRenderFns } from "./numberTextShadow.vue?vue&type=template&id=652f7341&"
import script from "./numberTextShadow.vue?vue&type=script&lang=ts&"
export * from "./numberTextShadow.vue?vue&type=script&lang=ts&"
import style0 from "./numberTextShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports